import React, { Fragment } from "react";

export default (
  <>
    <path d="M21.74 5.36l-.53-1.58c-.2-.6-.77-1.02-1.4-1.02h-4.46V1.31C15.35.6 14.76 0 14.04 0H9.96c-.72 0-1.31.59-1.31 1.31v1.45H4.19c-.63 0-1.2.41-1.4 1.02l-.53 1.58a1.2 1.2 0 001.13 1.57h.55l1.22 15.08C5.26 23.12 6.2 24 7.32 24h9.6c1.13 0 2.08-.88 2.17-2L20.3 6.93h.3a1.2 1.2 0 001.13-1.57zM10.05 1.41h3.9v1.35h-3.9zm7.63 20.48c-.03.4-.36.7-.75.7h-9.6c-.4 0-.74-.3-.77-.7L5.36 6.93h13.53zm-14-16.37l.44-1.3a.07.07 0 01.07-.05h15.62c.03 0 .06.02.07.05l.43 1.3z" />
    <path d="M15.44 21.84h.04a.7.7 0 00.7-.66l.66-12.68a.7.7 0 00-1.4-.07l-.66 12.67a.7.7 0 00.66.74zM7.85 21.18a.7.7 0 101.4-.08L8.56 8.43a.7.7 0 10-1.4.07zM12 21.84a.7.7 0 00.71-.7V8.46a.7.7 0 10-1.4 0v12.68c0 .39.3.7.7.7z" />
  </>
);
